module.exports = __webpack_public_path__ + "img/snippet-mask.aebca90.png";